export const maskFormat: { [key: string]: RegExp } = {
    "*": /[a-zA-Z0-9_]/,
  };
